import angular from 'angular'
import _ from 'lodash'

class Record {
  constructor(
    id,
    sourceUrl,
    legal,
    type,
    applicant,
    lessee,
    op,
    respondent,
    entity,
    map_date,
    summary
  ) {
    this.vaultDataId = id
    this.sourceUrl = sourceUrl
    this.legal = legal
    this.docType = type
    this.applicant = applicant
    this.lessee = lessee
    this.operator = op
    this.respondent = respondent
    this.entity = entity
    this.mapDate = map_date
    this.summary = summary
  }

  static fromJson(record) {
    return new Record(
      record.vaultDataId,
      record.source_url,
      record.legal,
      record.type_of_document,
      record.applicant,
      record.lessee,
      record.operator,
      record.respondent,
      record.applicant || record.lessee || record.operator || record.respondent,
      record.map_date,
      record.summary
    )
  }

  get whichEntityType() {
    const entityOptions = {
      Applicant: this.applicant,
      Operator: this.operator,
      Lessee: this.lessee,
      Respondent: this.respondent
    }
    return _(entityOptions)
      .omit(_.isNull)
      .keys()
      .first()
  }

  static fromJsonArray(records) {
    return _.map(
      records,
      record => Record.fromJson(record)
    )
  }

  static factory($resource, $log, config, RecordMapService) {
    return $resource(
      config.recordResourcePath,
      {pageSize: config.searchPageSize},
      {
        get: {
          method: 'GET',
          url: config.recordResourcePath,
          params: {recordId: '@recordId'},
          transformResponse: function instantiateRecords(data) {
            var response
            try {
              const jsonData = angular.fromJson(data)
              $log.debug(jsonData)
              response = RecordMapService.matchRecord(jsonData.records[0])
            } catch (e) {
              response = data
              $log.warn(`Error when retrieving record: ${response}`)
            }

            return response
          }
        },
        query: {
          method:'POST',
          isArray: false,
          timeout: 120000,
          cancellable: true,
          transformResponse: function instantiateRecords(data) {
            var response
            try {
              response = angular.fromJson(data)
              response.records = Record.fromJsonArray(response.records)
            } catch (e) {
              response = data
            }

            return response
          }
        }
      }
    )
  }
}

Record.factory.$inject = ['$resource', '$log', 'config', 'RecordMapService']

export default Record
